import React, { useEffect, useState } from "react"

import HeroLocationSearchBox from "../../HomePageV2Archived/components/HeroLocationSearchBox"

const HeroSearchBar = ({ location, onSearch, isMobile = false, className = "" }) => {
  const [searchQuery, setSearchQuery] = useState("")
  const [googlePlacesLoaded, setGooglePlacesLoaded] = useState(
    typeof window !== "undefined" && !!window.google?.maps?.places
  )

  // Wait for Google Places to be loaded
  useEffect(() => {
    if (googlePlacesLoaded) return
    const onLoaded = () => setGooglePlacesLoaded(true)
    document.addEventListener("googlePlacesLoaded", onLoaded)
    if (window.google?.maps?.places) setGooglePlacesLoaded(true)
    return () => document.removeEventListener("googlePlacesLoaded", onLoaded)
  }, [googlePlacesLoaded])

  const handleSubmit = (e) => {
    e.preventDefault()
    onSearch({ query: searchQuery, location })
  }

  const handleSearchChange = (e) => {
    const newQuery = e.target.value
    setSearchQuery(newQuery)
    if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
      sessionStorage.setItem("homepageSearchQuery", newQuery)
    }
  }

  return (
    <form onSubmit={handleSubmit} className={`w-full ${isMobile ? "" : "max-w-[576px]"} ${className}`}>
      <div
        className={`relative flex items-center rounded-[100px] border border-builder-border-light bg-white shadow-[0px_11px_36px_0px_rgba(0,0,0,0.09)] ${
          isMobile ? "h-[48px] gap-[8px] py-[4px] pl-[16px] pr-[8px]" : "gap-[16px] py-[16px] pl-[32px] pr-[16px]"
        }`}>
        {/* Search input - flex-1 */}
        <div className="flex min-w-0 flex-[1_0_0] items-center gap-[24px]">
          <input
            type="text"
            placeholder="Search by service or health concern…"
            value={searchQuery}
            onChange={handleSearchChange}
            className="min-w-0 flex-[1_0_0] bg-transparent outline-none placeholder:text-builder-secondary"
            style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
              color: "#0B3954"
            }}
          />

          {/* Right side: separator + location autocomplete (after Places loaded) - hidden on mobile per design */}
          {googlePlacesLoaded && !isMobile && (
            <div className="flex shrink-0 items-center gap-[16px] pr-[8px]">
              {/* Vertical separator */}
              <div className="h-40 w-px shrink-0 bg-builder-border-light" />

              {/* Location search box with Google Places autocomplete */}
              <div className="shrink-0">
                <HeroLocationSearchBox initialLocation={location} isMobile={isMobile} />
              </div>
            </div>
          )}
        </div>

        {/* Submit button - entrance pulse + hover nudge (see landingMotion.css) */}
        <button
          type="submit"
          aria-label="Search practitioners"
          className="landing-search-btn-animate flex size-[32px] shrink-0 items-center justify-center rounded-[200px] bg-builder-accent transition-colors duration-200 hover:bg-[#0B8B91] active:bg-[#0A7A7F]">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 12H19M19 12L12 5M19 12L12 19"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </form>
  )
}

export default HeroSearchBar
